__webpack_require__.p = "/kpi/";